import { forwardRef, useId } from 'react'
import { cn } from '@shared/lib/cn'
import { ErrorMessage } from '@shared/ui/ErrorMessage/ErrorMessage'
import { Label } from '../Label/Label'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
  wrapperClassName?: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, error, id, wrapperClassName, ...props }, ref) => {
    const generatedId = useId()
    const textareaId = id ?? (label ? generatedId : undefined)
    return (
      <div className={cn('flex flex-col gap-1', wrapperClassName)}>
        {label && (
          <Label htmlFor={textareaId} required={props.required}>
            {label}
          </Label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          className={cn(
            'border-border bg-surface min-h-25 w-full rounded-lg border px-3 py-2',
            'text-foreground placeholder:text-placeholder text-base',
            'focus:border-orange transition focus:outline-none',
            'disabled:cursor-not-allowed disabled:opacity-50',
            'resize-none',
            error && 'border-red focus:border-red',
            className
          )}
          {...props}
        />
        <ErrorMessage message={error} />
      </div>
    )
  }
)
Textarea.displayName = 'Textarea'
